<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>비밀번호 확인</dt>
            <dd>
                연락처 변경을위해 비밀번호 확인이 필요합니다.<br>
                비밀번호를 입력해주세요.
            </dd>
        </dl>
        <ul class="login_form">
            <li>
                <input type="password" placeholder="비밀번호" v-model="password">
            </li>
        </ul>
    </div>
    <div class="btn_box_fixed">
        <a class="default_btn1" @click="validate">비밀번호 확인</a>
    </div> 
</div>

</template>

<script>
export default {
    name:'PhonePwChk',

    created() {
        this.$store.commit('SHOW_ONLOAD');
    },

    data() {
        return {
            password: '',
        }
    },
    computed: {
    },
    methods: {
        validate() 
        {
            if(!this.password){
                this.$store.commit('OPEN_MODAL', {
                    content:'비밀번호를 입력해주세요.',
                    btnOne:'확인',
                })
                return 
            }
            
            this.submit();
        },

        submit(){
            this.$store.dispatch('CHECK_AUTH_PASSWORD', { password: this.password })
            .then(()=>{
                this.$store.commit('OPEN_MODAL', {
                    content: '비밀번호 확인이 완료되었습니다.',
                    btnOne:'확인',
                    btnOneSubmit: () => {
                        this.$router.push('/phone/niceAuth');
                    }
                })
            })
            .catch((e)=>{
                this.apiCatch(e);
            });
            
        }
    },

}
</script>

<style lang="scss" scoped>

</style>